import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient} from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class DealersService {
  constructor(private helper: Helper, private http: HttpClient) {
  }


  public getDealers(gridData) {
    return this.http.get(environment.apiUrl + '/backoffice/dealers/backoffice/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getBillingAccounts(gridData) {
    return this.http.get(environment.apiUrl + '/backoffice/dealers/backoffice/billing-accounts?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getAllDealers(gridData) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/dealers/backoffice/invoice-dealer?' + gridData.toString() + '&status=all')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getAllDealersList() {
    return this.http.get<any>(environment.apiUrl + '/backoffice/dealers/backoffice?'  + '&status=all')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getDealer(userId) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/dealers/backoffice/' + userId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getDeliveryDealersArchive(userId) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/dealers/backoffice/' + userId + '/archive')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageDealer(systemUser, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/dealers/backoffice/' + id, systemUser)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/dealers/backoffice/', systemUser)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public softDeleteDealer(id) {
    return this.http.delete(environment.apiUrl + '/backoffice/users/backoffice/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public softDeleteBackoffice(id) {
    return this.http.delete(environment.apiUrl + '/backoffice/users/backoffice/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public deactivateDealer2FA(id){
    return this.http.post(environment.apiUrl + '/backoffice/users/backoffice/deactivate-2fa/' + id, {})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public assignDealer(id, body){
    return this.http.put(environment.apiUrl + '/backoffice/quote/place/' + id, body)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public readdDealer(id) {
    return this.http.put(environment.apiUrl + '/backoffice/dealers/backoffice/' + id + '/reAdd',
      {id: id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageDealerCollectionDiscount(id, invoiceDealer) {
    return this.http.put(environment.apiUrl + '/backoffice/dealers/backoffice/' + id + '/collection-discounts', invoiceDealer)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getInvoiceDealer(gridData) {// '/backoffice/dealers/backoffice/?' + gridData.toString() + '&status=all'
    return this.http.get(environment.apiUrl + '/backoffice/dealers/backoffice/invoice-dealer/?' + gridData.toString())
      .pipe(map(rsp => rsp['data']), catchError(res => this.helper.catchError(res)));
  }

  public sync(id) {
    return this.http.post(environment.apiUrl + '/backoffice/dealers/backoffice/sync', {id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageDealerCollectionTransportationCost(id, invoiceDealer) {
    return this.http.put(environment.apiUrl + '/backoffice/dealers/backoffice/' + id + '/collection-transportation-costs', invoiceDealer)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
